var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoToast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5813 6.50453C21.4733 6.01336 21.2534 5.56333 20.9438 5.1999C20.6341 4.83647 20.2457 4.57251 19.8178 4.43467C18.2542 4 12 4 12 4C12 4 5.74578 4 4.18222 4.47607C3.75429 4.6139 3.36588 4.87787 3.05623 5.2413C2.74659 5.60473 2.52666 6.05476 2.41868 6.54593C2.13253 8.35245 1.99255 10.1851 2.00052 12.0207C1.99032 13.8702 2.1303 15.7167 2.41868 17.5369C2.53773 18.0128 2.76258 18.4457 3.0715 18.7938C3.38043 19.1419 3.76299 19.3933 4.18222 19.5239C5.74578 20 12 20 12 20C12 20 18.2542 20 19.8178 19.5239C20.2457 19.3861 20.6341 19.1221 20.9438 18.7587C21.2534 18.3953 21.4733 17.9452 21.5813 17.4541C21.8653 15.6612 22.0052 13.8425 21.9995 12.0207C22.0097 10.1712 21.8697 8.32466 21.5813 6.50453Z",
    fill: "#5A5A5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15L15 12L10 9V15Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoToast);
export default __webpack_public_path__ + "static/media/videoToast.5c1e0c17711c36f54eb5257203201e49.svg";
export { ForwardRef as ReactComponent };